<template>
  <BaseCheckboxSelector
    v-if="categoriesMapped"
    :color="medium"
    :disabled="disabled"
    :error-message="errorMessage"
    :items="categoriesMapped"
    :label="$t('category_checkbox_selector.category')"
    :model-value="value"
    selection-mode="exclude"
    sticky-header
    @update:model-value="updateModelValue"
  />
</template>

<script setup>
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import BaseCheckboxSelector from "shared/components/selectors/checkbox/BaseCheckboxSelector.vue";
import { useGlobalStore } from "shared/stores/global";

const props = defineProps({
  medium: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
  },
  required: {
    type: Boolean,
  },
  valid: {
    type: Boolean,
  },
});

const emit = defineEmits(["update:modelValue", "update:valid"]);

const value = ref(props.modelValue);

const { categories, socialCategories } = storeToRefs(useGlobalStore());

const categoriesList = computed(() =>
  props.medium === "social" ? socialCategories.value : categories.value
);

const hasSelectedCategories = computed(
  () =>
    categoriesList.value.filter(
      (category) => !value.value.includes(category.id)
    ).length > 0
);

const categoriesMapped = computed(() =>
  categoriesList.value.map((category) => ({
    id: category.id,
    name: category.name,
  }))
);

const errorMessage = computed(() => {
  if (props.required && !hasSelectedCategories.value) {
    return getLocaleText(
      "category_checkbox_selector.select_at_least_one_category"
    );
  }

  return "";
});

function updateModelValue(items) {
  value.value = items;
  emit("update:modelValue", items);
}

watch(
  hasSelectedCategories,
  (val) => {
    if (props.required) {
      emit("update:valid", val);
    }
  },
  { immediate: true }
);
</script>
